<div class="row mb-4">
    <p class="mb-1 total" style="text-align: right; margin-top: -20px; padding-right: 12px;">Mis cursos
        <strong>{{totalProducts}}</strong>
    </p>
    <div class="col-xs-12 col-sm-12">
        <div class="action d-flex justify-content-end align-items-center">
            <div class="d-flex align-items-center" style="flex: 1; margin-right: 10px;">
                <div style="flex: 0.9; margin-right: 10px;">
                    <label class="sr-only">Buscar por ítulo del curso</label>
                    <div class="input-group" style="width: 100%;">
                        <input type="text" class="form-control" style="width: 100%;" [(ngModel)]="search"
                            (ngModelChange)="updateSearchValue($event)" [ngModelOptions]="{standalone: true}"
                            (keyup)="loadData()" placeholder="Buscar por título del curso">
                    </div>
                </div>
                <!-- <select class="form-control" style="flex: 0.2; margin-right: 10px;" [(ngModel)]="selectedStatus" (change)="filterByStatus()"> -->
                <select class="form-control" style="flex: 0.2; margin-right: 10px;" [(ngModel)]="selectedStatus"
                    (change)="filterCoursesByStatus()">

                    <option value="">Estado</option>
                    <option value="todos">Todos</option>
                    <option value="borrador">Borrador</option>
                    <option value="revisión">Revisión</option>
                    <option value="publicado">Publicado</option>
                </select>
                <button *ngIf="search || selectedStatus" class="btn btn-danger"
                    style="white-space: nowrap; margin-right: 10px;" (click)="clearSearch()">
                    Borrar Filtro
                </button>
            </div>
            <div class="d-flex">
                <a class="btn btn-primary btn-sm" style="white-space: nowrap;" [routerLink]="['add-ebook']">
                    Agregar
                </a>
            </div>
        </div>
    </div>
</div>

<div class="table-template">
    <!-- Spinner de carga -->
    <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando...</span>
        </div>
        <p class="mt-2">Cargando ebooks...</p>
    </div>

    <table class=" table table-lg table-hover row-border hover" *ngIf="!loading">
        <thead>
            <tr>
                <!-- <th>Imagen</th> -->
                <th style="width: 15%;">Título</th>
                <th style="width: 15%;" *ngIf="!isInstructor">Instructor</th>
                <th style="width: 10%;">Precio</th>
                <th style="width: 15%;">Categoría</th>
                <th style="width: 10%;">Nivel</th>
                <th style="width: 10%;">Status</th> <!-- Nueva columna -->
                <!-- <th style="width: 10%;">Total de horas</th> -->
                <th style="width: 10%;">Acciones</th>
            </tr>
        </thead>
        <tbody>
            <!-- <tr *ngFor="let course of product_list"> -->
            <!-- <td><img width="80px" height="auto" [src]="course.ImgFileUrl"></td> quite img-->
            <!-- <tr *ngFor="let course of filteredProductList"> -->
            <tr *ngFor="let ebook of paginatedCourses" [hidden]="ebook.Active === false">
                <td>{{ebook?.Title || 'Sin título'}}</td>
                <td *ngIf="!isInstructor">
                    {{ebook?.user?.displayName || ebook?.User?.displayName || currentUser?.displayName || 'Sin instructor'}}
                </td>
                <td>{{(ebook?.UnitPrice || 0) | currency:'MXN':'symbol-narrow':'1.2-2' }}</td>
                <td>{{ebook?.Category?.ValueAlpha || ebook?.category?.ValueAlpha || 'Sin categoría'}}</td>
                <td>{{ebook?.Level?.ValueAlpha || ebook?.level?.ValueAlpha || 'Sin nivel'}}</td>
                <td>
                    <button disabled class="btn btn-sm" [ngClass]="{
                            'btn-success': ebook?.Status?.toLowerCase() === 'published' || ebook?.Status?.toLowerCase() === 'publicado',
                            'btn-warning': ebook?.Status?.toLowerCase() === 'review' || ebook?.Status?.toLowerCase() === 'revision' || ebook?.Status?.toLowerCase() === 'revisión',
                            'btn-secondary': ebook?.Status?.toLowerCase() === 'draft' || ebook?.Status?.toLowerCase() === 'borrador',
                            'btn-light': !ebook?.Status
                        }">
                      {{
                        (ebook?.Status?.toLowerCase() === 'draft' || ebook?.Status?.toLowerCase() === 'borrador')
                          ? 'Borrador'
                          : (ebook?.Status?.toLowerCase() === 'review' || ebook?.Status?.toLowerCase() === 'revision' || ebook?.Status?.toLowerCase() === 'revisión')
                          ? 'Revisión'
                          : (ebook?.Status?.toLowerCase() === 'published' || ebook?.Status?.toLowerCase() === 'publicado')
                          ? 'Publicado'
                          : 'Sin status (' + ebook?.Status + ')'
                      }}
                    </button>
                </td>                  

                <!-- <td>{{course.status ? 'Publicado' : 'Revisión'}}</td> Estado del curso -->
                <!-- <td>{{course.TotalHours}}</td> -->
                <td class="actions-cell">
                    <div ngbDropdown class="d-inline-block">
                        <button class="btn btn-sm btn-light" type="button" [id]="'dropdownMenuButton' + ebook.id" 
                                ngbDropdownToggle>
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <div ngbDropdownMenu [attr.aria-labelledby]="'dropdownMenuButton' + ebook.id">
                            <a class="dropdown-item" [routerLink]="['/products/ebook-detail', ebook.id]" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">remove_red_eye</mat-icon>
                                Ver detalle
                            </a>
                            <a class="dropdown-item" 
                               *ngIf="ebook.Status?.toLowerCase() === 'draft' || ebook.Status?.toLowerCase() === 'borrador'"
                               [routerLink]="['/products/ebooks/edit', ebook.id]" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">edit</mat-icon>
                                Editar
                            </a>
                            <a class="dropdown-item" *ngIf="ebook.Status?.toLowerCase() === 'draft' || ebook.Status?.toLowerCase() === 'borrador'" 
                               href="javascript:void(0);" 
                               (click)="sendToReview(ebook.id)" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">send</mat-icon>
                                Enviar a revisión
                            </a>
                            <a class="dropdown-item" [routerLink]="['/products/product-landing', ebook.id]"
                               [queryParams]="{type: 'ebook'}" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">ballot</mat-icon>
                                Landing page
                            </a>
                            <a class="dropdown-item"
                               href="javascript:void(0);"
                               (click)="copiarURL(ebook)" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">link</mat-icon>
                                Copiar URL
                            </a>
                            <div class="dropdown-divider" *ngIf="ebook.Status?.toLowerCase() !== 'published' && ebook.Status?.toLowerCase() !== 'publicado'"></div>
                            <a class="dropdown-item text-danger" 
                               *ngIf="ebook.Status?.toLowerCase() !== 'published' && ebook.Status?.toLowerCase() !== 'publicado'" 
                               href="javascript:void(0);" 
                               (click)="confirmDelete(ebook.id)" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">delete</mat-icon>
                                Eliminar
                            </a>
                        </div>
                    </div>
                </td>
            </tr>

            <!-- Mensaje cuando no hay resultados -->
            <tr *ngIf="filteredCourses.length === 0">
                <td [attr.colspan]="isInstructor ? 6 : 7" class="text-center py-4">
                    <p class="text-muted mb-0">
                        <mat-icon style="vertical-align: middle;">info</mat-icon>
                        No se encontraron ebooks
                    </p>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<!-- Controles de paginación -->
<div class="pagination-controls d-flex justify-content-center align-items-center mt-4" *ngIf="filteredCourses.length > 0">
    <nav aria-label="Paginación">
        <ul class="pagination mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="previousPage()" aria-label="Anterior">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>
            
            <li class="page-item" *ngFor="let page of getPageNumbers()" [class.active]="page === currentPage">
                <a class="page-link" (click)="goToPage(page)">{{page}}</a>
            </li>
            
            <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a class="page-link" (click)="nextPage()" aria-label="Siguiente">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>
        </ul>
    </nav>
    <div class="text-muted small ms-3">
        Página {{currentPage}} de {{totalPages}} ({{totalProducts}} ebooks totales)
    </div>
</div>

<!-- Modal definition (add this at the bottom of your template) -->
<ng-template #modal let-modal class="modal-dialog">
        <div class="text-center">
            <div class="modal-header justify-content-end"> <!-- Alinea el botón de cerrar a la derecha -->
                <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
            </div>
            <h5 class="modal-title">¿Deseas asesoría para estructurar tu curso?</h5>
            <div class="modal-footer">
                <a class="btn btn-primary btn-lg" (click)="modal.close()" [routerLink]="['add-ebook']">
                    Sí, quiero asesoría
                </a>
            </div>
        </div>
    </ng-template>